import { Spacing } from '@billy/design-system'
import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

import { COLLAPSE_ANIMATION_MS } from './constants/collapseAnimationMs'

const COLLAPSE_ANIMATION_S = COLLAPSE_ANIMATION_MS / 1000

interface ExpandableProps {
  isVisible: boolean
  isFullyClosed: boolean
}

export const ExpandableWrapper = styled.div<ExpandableProps>`
  display: grid;
  visibility: ${({ isFullyClosed }) => (isFullyClosed ? 'hidden' : 'visible')};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  grid-template-rows: ${({ isVisible }) => (isVisible ? '1fr' : '0fr')};
  padding-bottom: ${({ isVisible }) => (isVisible ? Spacing.S16 : '0')};
  pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
  transition:
    grid-template-rows ${COLLAPSE_ANIMATION_S}s ease-in-out,
    opacity ${COLLAPSE_ANIMATION_S}s ease-in-out,
    padding-bottom ${COLLAPSE_ANIMATION_S}s ease-in-out;
`

export const ExpandableContent = styled.div`
  overflow: hidden;
`

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

export const TagsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  animation: ${fadeIn} 0.1s ease-in-out;
`
